var map = {
	"./switch-off.png": 248,
	"./switch-on.png": 249
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 247;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro ^\.\/switch\-.*\.png$
// module id = 247
// module chunks = 0